import Grid from "@mui/material/Grid2";
import "./styles/responsive-row.css";

const ResponsiveRow = ({ children, type }) => {
  return (
    <Grid className={`responsive-row ${type}`} container spacing={2}>
      {children}
    </Grid>
  );
};

export default ResponsiveRow;
